// import { ReactLenis } from "lenis/dist/lenis-react";
import { ThemeProvider } from "@mui/material";
import { customTheme } from "../utils/theme";
import { defaultTheme } from "../utils/const";
import { useAuth } from "../provider/AuthContext";
// import Header from "../components/header";

function PublicRoute({ children }) {
  const { settings } = useAuth();
  const theme = settings?.platform?.theme || defaultTheme;
  const appliedTheme = customTheme[theme];
  
  return (
    <ThemeProvider theme={appliedTheme}>
      {children}
    </ThemeProvider>
  );
}

export default PublicRoute;
